import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isFree", "offeringType", "onClick", "section", "slug"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useContext } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import UIButton from 'UIComponents/button/UIButton';
import { getAppShortlink } from 'marketplace-ui-assets-core/utils/urls';
import { getDetailsRoute } from '../../utils/urls';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext';
import { jsx as _jsx } from "react/jsx-runtime";
function AssetSignInButton(_ref) {
  let {
      isFree,
      offeringType,
      onClick,
      section,
      slug
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    trackDetailsInteraction
  } = useContext(StorefrontUsageTrackerContext);
  const detailsPageShortLink = getAppShortlink({
    pathname: getDetailsRoute(offeringType, slug),
    theme: slug
  });
  const handleClick = useCallback(evt => {
    trackDetailsInteraction('click sign in cta button', {
      section
    });
    if (onClick) onClick(evt);
  }, [onClick, section, trackDetailsInteraction]);
  const renderSignInButtonText = isFree ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.details.tryAsset",
    options: {
      offeringType: unescapedText(`marketplace-assets-ui.details.offeringType.${offeringType}_lowercase`)
    }
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "marketplace-assets-ui.details.purchase"
  });
  return /*#__PURE__*/_jsx(UIButton, Object.assign({}, rest, {
    href: detailsPageShortLink,
    onClick: handleClick,
    use: "primary",
    children: renderSignInButtonText
  }));
}
export default AssetSignInButton;